import React from 'react';

function Competencies() {
  const competencies = [
    {
      number: '01',
      title: 'Integrated Problem Solving',
      subtitle: '통합적 문제해결',
      description: '현장의 문제를 파편화된 개별 요소가 아닌, 사람·업무·프로세스·조직·전략이 유기적으로 맞물린 하나의 연결된 시스템으로 분석합니다.\n\n단편적인 증상 처방에 그치지 않고 현상의 이면에 숨겨진 근본 원인(Root Cause)을 추적하여, 비즈니스 구조 전반의 개선 방향을 설계합니다.'
    },
    {
      number: '02',
      title: 'Data-driven Analysis',
      subtitle: '데이터 기반 분석',
      description: '주관적이거나 정성적인 의견에만 의존하지 않고, 철저한 현장 데이터와 객관적 근거에 기반한 합리적 의사결정을 지원합니다.\n\n조직 진단, 적정 인력 산정, 운영 모델 설계 등 고도의 정량·정성 분석 방법론을 활용하여 클라이언트가 신뢰할 수 있는 명확한 근거를 제시합니다.'
    },
    {
      number: '03',
      title: 'Execution-oriented Consulting',
      subtitle: '실행 중심 컨설팅',
      description: '이론적이고 화려한 보고서 제출에 그치지 않고, 클라이언트의 조직 환경과 수용 가능성을 고려해 현장에서 \'실제 작동하는 실행 방안\'을 도출합니다.\n\n전략과 실행 사이의 간극을 최소화하여 실질적인 변화가 현장에 정착될 수 있도록 지원합니다.'
    },
    {
      number: '04',
      title: 'Public Sector Expertise',
      subtitle: '공공부문 전문성',
      description: '공공기관 및 공기업의 고유한 운영 환경과 규제, 정책적 특성을 깊이 있게 이해하고 이에 최적화된 조직·인력·운영체계 개선을 지원합니다.\n\n풍부한 연구용역 수행, 경영평가 대응, 공공 조직진단 경험을 기반으로 공공의 가치와 경영 효율성을 동시에 충족하는 개선 방안을 제시합니다.'
    },
    {
      number: '05',
      title: 'Digital Transformation',
      subtitle: '디지털 전환 역량',
      description: '데이터, AI, 최신 디지털 기술을 비즈니스 프로세스에 융합하여 실질적인 업무 혁신과 운영 효율화를 견인합니다.\n\n기술의 단순 도입을 넘어, 기업의 고유한 업무 맥락과 조직 문화에 자연스럽게 녹아들 수 있도록 가장 최적화된 방식으로 기술을 연결합니다.'
    }
  ];

  return (
    <section id="competencies" className="competencies-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Core Competencies</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="competencies-grid">
          {competencies.map((competency, index) => (
            <div key={index} className="competency-card">
              <div className="competency-number">{competency.number}</div>
              <h3 className="competency-title">{competency.title}</h3>
              <p className="competency-subtitle">{competency.subtitle}</p>
              <p className="competency-description">
                {competency.description.split('\n\n').map((paragraph, idx) => (
                  <React.Fragment key={idx}>
                    {paragraph}
                    {idx < competency.description.split('\n\n').length - 1 && <><br/><br/></>}
                  </React.Fragment>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Competencies;
